import { render, staticRenderFns } from "./ConfigFormCreate.vue?vue&type=template&id=3ab1a633&"
import script from "./ConfigFormCreate.vue?vue&type=script&lang=js&"
export * from "./ConfigFormCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports